import { IEquipment } from '@/pages/Equipment/equipment.types'
import liftPlateContactsMatrixConfig from '../liftPlateContactsMatrix.config'
import LiftPlateContactsMatrixWidget from '../LiftPlateContactsMatrixWidget'
import useParametersValuesRange from '@/services/data/hooks/useParametersValuesRange'
import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { useRecoilValue } from 'recoil'
import { useMemo } from 'react'

interface IProps {
  equipmentId: IEquipment['id']

  tsFrom: number
  tsTo: number
  tsCurrent: number
}

const LiftPlateContactsMatrixRange = (props: IProps) => {
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const config = useMemo(
    () => ({
      tsFrom: props.tsFrom,
      tsTo: props.tsTo,
      equipmentId: props.equipmentId,
      parameters: liftPlateContactsMatrixConfig.sourceParametersMap
        .flatMap((el) => el)
        .map((e) => sourceIdToIdMap[e])
        .filter(Boolean),
    }),
    [sourceIdToIdMap, props.tsFrom, props.equipmentId, props.tsTo]
  )

  const ctrl = useParametersValuesRange({
    ...config,
    tsCurrent: props.tsCurrent,
  })

  return <LiftPlateContactsMatrixWidget values={ctrl.values} loading={ctrl.loading} />
}

export default LiftPlateContactsMatrixRange
